import { Link } from "@tanstack/react-router";
import { ArrowRight, ShieldCheck } from "lucide-react";
import ownerPhoto from "../assets/owner/luis-torres-owner.webp.asset.json";

export function OwnerTrust() {
  return (
    <section aria-labelledby="owner-trust-title" className="bg-[var(--brand-light-gray)] py-10 md:py-12">
      <div className="mx-auto max-w-[1000px] px-4">
        <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
          <div className="grid min-w-0 items-stretch sm:grid-cols-[220px_minmax(0,1fr)] md:grid-cols-[280px_minmax(0,1fr)]">
            <div className="relative min-h-[280px] sm:min-h-full">
              <img
                src={ownerPhoto.url}
                alt="Luis, owner and operator of Capital Pro Pressure Washing, at a completed stamped concrete project"
                width={720}
                height={960}
                loading="lazy"
                decoding="async"
                className="absolute inset-0 h-full w-full object-cover object-[42%_58%]"
              />
            </div>

            <div className="flex min-w-0 flex-col justify-center p-6 md:p-9">
              <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-red)]">
                Owner Operated
              </p>
              <h2
                id="owner-trust-title"
                className="text-3xl uppercase leading-tight text-[var(--brand-deep-blue)] md:text-4xl"
                style={{ fontFamily: "var(--font-display)", fontWeight: 700 }}
              >
                Meet Luis, The Owner Behind Capital Pro
              </h2>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-[var(--brand-charcoal)]/85">
                When you call Capital Pro, you talk directly with the owner. Luis and the same local crew that quotes your project show up to do the work—no franchise call center or unknown subcontractors.
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-4">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 font-bold text-[var(--brand-deep-blue)] transition-colors hover:text-[var(--brand-red)]"
                >
                  Meet Capital Pro
                  <ArrowRight size={18} aria-hidden="true" />
                </Link>
                <span className="inline-flex items-center gap-2 text-sm font-semibold text-[var(--brand-charcoal)]/75">
                  <ShieldCheck size={18} className="text-[var(--brand-red)]" aria-hidden="true" />
                  Veteran owned · 10+ years local
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}